import http from "@/shared/services/http";
import {PartnerParams} from "@/modules/partners/params";

export const createPartner = (data: any) => http.post(`v1/partners`, data);
export const listPartner = (params?: PartnerParams) => http.get(`v1/partners`, { params });
export const singlePartner = (rowGuid: string) => http.get(`v1/partners/${rowGuid}`);
export const updatePartner = (rowGuid: string, data: any) => http.put(`v1/partners/${rowGuid}`, data);
export const deletePartner = (rowGuid: string) => http.delete(`v1/partners/${rowGuid}`);